import { render, staticRenderFns } from "./ManageSavedTemplate.vue.js?vue&type=template&id=28b874ae!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ManageSavedTemplate.vue?vue&type=template&id=28b874ae"
import script from "./ManageSavedTemplate.vue.js?vue&type=script&setup=true&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ManageSavedTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageSavedTemplate.vue.js?vue&type=script&setup=true&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ManageSavedTemplate.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ManageSavedTemplate.vue.css?vue&type=style&index=0&id=28b874ae&prod&lang=css!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ManageSavedTemplate.vue?vue&type=style&index=0&id=28b874ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports